import { memo, type ReactNode } from 'react'

import { GiftReturnLuck } from '../../gifts/gift-return-luck'
import { QuantityGiftSent } from '../../gifts/quantity-gift-sent'
import { UserLevelUp } from '../../lives/user-level-up'
import { ToastBubbleMessage } from '../toast-bubble-message'
import { ToastEarnedGlobal } from '../toast-earned-global'

// cada toast é self-contained e desenha um container próprio full-screen; pra
// EMPILHAR (sobrepor) em vez de ficar um embaixo do outro, cada um vai numa
// camada absoluta.
const Layer = ({ children }: { children: ReactNode }) => (
  <div className="absolute inset-0 pointer-events-none">{children}</div>
)

/**
 * Página ÚNICA que renderiza os toasts SEGUROS da live numa só WebView.
 *
 * Antes o app RN montava 8 WebViews full-screen transparentes EM PARALELO (uma
 * por tipo de toast) → 8 camadas de overdraw compostas todo frame + 8 instâncias
 * de WebView na memória (num aparelho de 1GB isso pesa MUITO). Aqui é 1 WebView =
 * 1 camada / 1 processo de renderer p/ os 5 toasts abaixo.
 *
 * ⚠️ FICAM DE FORA (webviews separadas no RN) os 3 ESPECIAIS — mesclá-los quebrou
 * posição na tentativa anterior:
 *   - /toast-rocket-game   → clicável + faixa central de 100px.
 *   - /return-value-luck   → zIndex 1030/elev 40 (acima do modal de gift) + 3
 *                            posições dinâmicas (a "estrela" que sumiu).
 *   - /toast-send-global   → usa <canvas id="canvas"> (id não-único → num doc
 *                            mesclado pegaria o canvas errado).
 *
 * Cada toast aqui segue self-contained: lê os mesmos params da URL
 * (liveId, liveCountry, myUserId, token) e assina seu próprio canal de pubsub;
 * só aparece quando há notificação daquele tipo. Todos usam Framer Motion
 * (animação presa a ref, sem CSS global/@keyframes) → não colidem no mesmo doc.
 */
export const ToastsAll = memo(() => {
  return (
    <div className="relative w-screen h-screen bg-transparent pointer-events-none">
      <Layer>
        <ToastEarnedGlobal />
      </Layer>
      <Layer>
        <UserLevelUp />
      </Layer>
      <Layer>
        <QuantityGiftSent />
      </Layer>
      <Layer>
        <GiftReturnLuck />
      </Layer>
      <Layer>
        <ToastBubbleMessage />
      </Layer>
    </div>
  )
})

ToastsAll.displayName = 'ToastsAll'
